import React from "react";
import { Row, Col, Icon } from "antd";
import BaseModal from "../../components/BaseModal";
import Copyable from "../../components/common/Copyable";

const ImportOrderModal = ({ visible, onCancel, data, history }) => {
  const handleRedirect = (clonedOrderId) => {
    if (history && clonedOrderId) {
      onCancel();
      history.push(`/orders/${clonedOrderId}/details?open_import_modal=true`);
    }
  };

  const listData = Array.isArray(data) ? data : (data ? [data] : []);

  return (
    <BaseModal
      title="Import Order Created"
      visible={visible}
      onCancel={onCancel}
      width="550px"
      footer={null}
      destroyOnClose
    >
      <div style={{ padding: "8px 0" }}>
        {/* Header Row */}
        <Row
          type="flex"
          style={{
            borderBottom: "2px solid #f0f0f0",
            paddingBottom: "8px",
            marginBottom: "12px",
            fontWeight: "600",
            color: "#595959",
            fontSize: "13px",
            textTransform: "uppercase",
            letterSpacing: "0.5px"
          }}
        >
          <Col span={12}>Bonded Order</Col>
          <Col span={12}>Imported Order</Col>
        </Row>

        {/* Content Rows */}
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {listData.map((item, index) => {
            const sourceNo = item.source_order_number;
            const clonedNo = item.cloned_order_no;
            const clonedId = item.cloned_order_id;

            return (
              <Row
                type="flex"
                align="middle"
                key={index}
                style={{
                  padding: "8px 0",
                  borderBottom: index < listData.length - 1 ? "1px solid #f5f5f5" : "none"
                }}
              >
                {/* Bonded Order Column */}
                <Col span={12}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <span style={{ fontSize: "14px", color: "#262626", fontWeight: "500" }}>
                      {sourceNo || "NA"}
                    </span>
                    {sourceNo && (
                      <Copyable text={sourceNo}/>
                    )}
                  </div>
                </Col>

                {/* Imported Order Column */}
                <Col span={12}>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    {clonedNo ? (
                      <span
                        onClick={() => handleRedirect(clonedId)}
                        style={{
                          fontSize: "14px",
                          color: "#1890ff",
                          fontWeight: "600",
                          textDecoration: "underline",
                          cursor: "pointer",
                          transition: "color 0.2s"
                        }}
                        onMouseEnter={(e) => (e.target.style.color = "#40a9ff")}
                        onMouseLeave={(e) => (e.target.style.color = "#1890ff")}
                      >
                        {clonedNo}
                      </span>
                    ) : (
                      <span style={{ fontSize: "14px", color: "#bfbfbf" }}>NA</span>
                    )}
                    {clonedNo && (
                      <Copyable text={clonedNo} />
                    )}
                  </div>
                </Col>
              </Row>
            );
          })}
        </div>
      </div>
    </BaseModal>
  );
};

export default ImportOrderModal;
